const ActionButtons = ({ onFaqClick }) => {
  return (
    <div className="action-buttons">
      <button 
        onClick={onFaqClick}
        className="action-btn"
      >
        How-To
      </button>
      
      {/* <a 
        href="/register" 
        target="_blank" 
        rel="noopener noreferrer"
        className="action-btn"
      >
        <button className="action-btn">Register</button>
      </a> */}
      
    </div>
  );
};

export default ActionButtons;